var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3317_1675)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.888 5.7871V18.9534C24.888 19.6281 24.3407 20.1753 23.6661 20.1753H1.22191C0.54727 20.1753 0 19.6281 0 18.9534V5.7871C0 5.11246 0.54727 4.56519 1.22191 4.56519H23.6661C24.3407 4.56519 24.888 5.11246 24.888 5.7871ZM25.7768 7.67627H26.7726C27.45 7.68005 27.9972 8.22894 27.9994 8.90574V22.0963C27.9994 22.7699 27.4462 23.342 26.7726 23.342H4.32088C3.64732 23.342 3.11084 22.7699 3.11084 22.0963V21.0644H23.6471C24.8108 21.0644 25.7768 20.135 25.7768 18.9709V7.67627Z",
    fill: "url(#paint0_linear_3317_1675)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.12695 8.56346L5.12695 16.6985C5.12695 17.0094 4.87491 17.2619 4.56349 17.2619C4.25208 17.2619 4.00003 17.0099 4.00003 16.6985L4.00003 8.56346C4.00003 8.25259 4.25208 8 4.56349 8C4.87491 8 5.12695 8.25205 5.12695 8.56346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.127 8.56346L21.127 16.6985C21.127 17.0094 20.8749 17.2619 20.5635 17.2619C20.2521 17.2619 20 17.0099 20 16.6985L20 8.56346C20 8.25259 20.2521 8 20.5635 8C20.8749 8 21.127 8.25205 21.127 8.56346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 3,
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3317_1675",
    x1: -4.17224e-7,
    y1: 23.3419,
    x2: 28.9494,
    y2: 21.7407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8764FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3317_1675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.562c3c1506f5f5d15ab4fb8f97ce8595.svg";
export { ForwardRef as ReactComponent };